import React from 'react';
import { DjayIllustrationProps } from '../types';
import { DjayIllustrationBase } from '../DjayIllustrationBase';
import { DjaySpecimen } from '../../DjaySpecimen';
export function UntouchableIllustration({
  variant = 'default',
  isUnlocked,
  rarity,
  size = 'md',
  animate = true,
  className = ''
}: DjayIllustrationProps) {
  return <DjayIllustrationBase isUnlocked={isUnlocked} rarity={rarity} size={size} className={className} data-id="element-4010">
      <div className="relative w-full h-full bg-gradient-to-br from-cyan-200 via-sky-300 to-indigo-400 overflow-hidden" data-id="element-4011">
        {/* Background: Diamond facets */}
        <svg className="absolute inset-0 w-full h-full z-0" viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-4012">
          <circle cx="100" cy="95" r="80" fill="#CFFAFE" opacity="0.4" data-id="element-4013" />
          <g transform="translate(100, 95)" opacity="0.5" data-id="element-4014">
            {[...Array(6)].map((_, i) => <path key={i} d="M0 0 L0 -70" stroke="#FFFFFF" strokeWidth="2" transform={`rotate(${i * 60})`} data-id="element-4015" />)}
          </g>
        </svg>

        {/* Djay */}
        <div className="absolute inset-0 z-10 flex items-center justify-center pt-[8%]" data-id="element-4016">
          <div className="w-[64%] h-[64%] flex items-center justify-center" data-id="element-4017">
            <DjaySpecimen look={{
            variant
          }} size="hero" emotion={isUnlocked ? 'proud' : 'sleeping'} animate={animate && isUnlocked} className="w-full h-full" data-id="element-4018" />
          </div>
        </div>

        {/* Foreground: Diamond + "25" */}
        {isUnlocked && <svg className="absolute inset-0 w-full h-full z-20 pointer-events-none" viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-4019">
            <g transform="translate(100, 34)" data-id="element-4020">
              <path d="M-16 -4 L-8 -12 L8 -12 L16 -4 L0 14 Z" fill="#67E8F9" stroke="#0E7490" strokeWidth="1.5" data-id="element-4021" />
              <path d="M-16 -4 L16 -4" stroke="#0E7490" strokeWidth="1" data-id="element-4022" />
            </g>
            <path d="M-10 152 Q100 178 210 152 L210 200 L-10 200 Z" fill="#3730A3" opacity="0.82" data-id="element-4023" />
            <text x="100" y="184" textAnchor="middle" fontFamily="sans-serif" fontSize="18" fontWeight="900" fill="#A5F3FC" data-id="element-4024">
              25 perfect
            </text>
          </svg>}
      </div>
    </DjayIllustrationBase>;
}